export default __webpack_public_path__ + "static/media/PhoneApp.d6358547.svg";